import { Box, Button, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ConsoleLogger, CookieStorage } from 'aws-amplify/utils';

export const ReservationChangeDone = (props: any) => {
  const navigate = useNavigate();
  // 予約変更の予約日時フォーム遷移時facilityIdはセットされている
  const facilityId = props.currentState.facilityId || '';

  const linkToAgreement = () => {
    // mynumber関連の施設IDの仕様が未確定のため、現時点ではmynumberに関連する施設IDのみを
    // セッションストレージとcookieに保存する仕様としている
    // mynumber周り以外は、sessionStorageは廃止しているため、この処理は暫定的なもの
    sessionStorage.setItem('facility_id', facilityId);
    const cookie = new CookieStorage();
    cookie.setItem('facility_id', facilityId);

    navigate(`/patient/agreement?reserveId=${props.currentState.reserveid}`);
  };

  return (
    <Grid container direction={'row'} justifyContent="center">
      <Grid item xs={1} md={3} sm={2} />
      <Grid item xs={10} md={6} sm={8}>
        <Typography className="font-bold" textAlign={'center'} marginTop={5}>
          ご予約を変更しました
        </Typography>
        <Box display="flex" justifyContent="space-between">
          <Button className="bg-primary" variant="contained" fullWidth onClick={linkToAgreement} sx={{ mt: 5, mb: 2 }}>
            <Typography className="text-white" sx={{ my: 0.5 }}>
              次へ進む
            </Typography>
          </Button>
        </Box>
      </Grid>
      <Grid item xs={1} md={3} sm={2} />
    </Grid>
  );
};
